import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  class: "w-4 h-4 animate-spin flex-shrink-0",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]


export default /*#__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
    buttonText: null,
    isDisabled: { type: Boolean },
    uploading: { type: Boolean },
    className: null,
    handleClick: { type: Function }
  },
  setup(__props: any) {

const { buttonText, isDisabled, uploading, handleClick } = __props as {
  buttonText: string;
  isDisabled: boolean;
  uploading: boolean;
  className?: string;
  handleClick: () => void;
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(__props.className)
  }, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.handleClick && __props.handleClick(...args))),
      disabled: __props.isDisabled,
      type: "button",
      class: "inline-flex items-center justify-center gap-2 w-full px-6 py-3 bg-[#6CC551] hover:bg-green-600 disabled:opacity-50 disabled:cursor-not-allowed text-white text-sm font-semibold rounded-xl transition-colors focus:outline-none focus:ring-2 focus:ring-[#6CC551]/40 focus:ring-offset-2"
    }, [
      (__props.uploading)
        ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_5))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(__props.uploading ? 'Processing…' : __props.buttonText), 1)
    ], 8, _hoisted_1)
  ], 2))
}
}

})